import React, { useRef, useState, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { Link } from "react-router-dom";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import firebase from '../../config/firebase';
import { useSelector } from 'react-redux';
import InputMask from 'react-input-mask';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GlobalSuccessModal, GlobalConfirmModal } from '../modalGlobal/modalGlobal';

require('firebase/auth')

const DataClientTable = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [datas, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const searchInput = useRef(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [ClientToDelete, setClientToDelete] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const user = useSelector(state => state.user);


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      if (user.viewALL) {
        const snapshot = await firebase.firestore()
          .collection('client')
          .get();
        const documents = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        setData(documents);
        setLoading(false);
      }
      else {
        if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
          const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          if (uids.length > 1) {
            const snapshot = await firebase.firestore().collection('client')
              .where('uidShipper', 'in', uids)
              .get();
            const documents = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setData(documents);
            setLoading(false);
          }
          else {
            const snapshot = await firebase.firestore().collection('client')
              .where("uidShipper", "==", user.uidShipper)
              .get();
            const documents = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setData(documents);
            setLoading(false);
          }
        }
        else {
          const snapshot = await firebase.firestore().collection('client')
            .where("uidShipper", "==", user.uidShipper)
            .get();
          const documents = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setData(documents);
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar dados dos clientes:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleDeleteClick = (id) => {
    setClientToDelete(id);
    setOpenConfirmModal(true);
  };
  const handleConfirmDelete = () => {
    setOpenConfirmModal(false);
    if (!ClientToDelete) return;
    firebase.firestore()
      .collection('client')
      .doc(ClientToDelete)
      .delete()
      .then(() => {
        setOpenSuccessModal(true);
        fetchData();
      })
      .catch((error) => {
        console.error("Erro ao excluir cliente:", error);
      });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),

    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),

    onFilter: (value, record) => {

      if (dataIndex === 'cpfCnpj') {
        const cleanValue = value.replace(/[^\w]/g, '').trim();

        return (
          (record.cpf && record.cpf.toString().replace(/[^\w]/g, '').toLowerCase().includes(cleanValue.toLowerCase())) ||
          (record.cnpj && record.cnpj.toString().replace(/[^\w]/g, '').toLowerCase().includes(cleanValue.toLowerCase()))
        );
      }
      else if (typeof value === 'string') {
        return record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase())
      }
      else {
        return record[dataIndex] = value
      }

    }, onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      ellipsis: true,
      key: 'name',
      width: '30%',
      ...getColumnSearchProps('name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Nome Fantasia',
      ellipsis: true,
      dataIndex: 'nameFantasy',
      key: 'nameFantasy',
      width: '20%',
      ...getColumnSearchProps('nameFantasy'),
      sorter: (a, b) => {
        const nameA = a.nameFantasy || '';
        const nameB = b.nameFantasy || '';
        return nameA.localeCompare(nameB);
      },
    },
    {
      title: 'CPF/CNPJ',
      ellipsis: true,
      dataIndex: 'cpfCnpj',
      key: 'cpfCnpj',
      ...getColumnSearchProps('cpfCnpj'),
      render: (text, record) => {
        if (record.cpf) {
          return <InputMask placeholder="00.000.000/0000-00" mask="999.999.999-99" value={record.cpf} disabled style={{
            border: 'none',
            backgroundColor: 'transparent',
            width: 'auto',
            padding: '0 5px',
            fontSize: '14px',
            color: '#444',
          }} />;

        } else if (record.cnpj) {
          return <InputMask placeholder="00.000.000/0000-00" mask="99.999.999/9999-99" value={record.cnpj} disabled style={{
            border: 'none',
            backgroundColor: 'transparent',
            width: 'auto',
            padding: '0 5px',
            fontSize: '14px',
            color: '#444',
          }} />;
        } else {
          return null;
        }
      },
      sorter: (a, b) => {
        const valueA = a.cpf || a.cnpj || '';
        const valueB = b.cpf || b.cnpj || '';
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: 'Ações',
      width: '10%',
      ellipsis: true,
      // dataIndex: 'data',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {
            user?.permissoes?.cliente?.editar || user?.permissoes?.client?.isEdit ? (
              <Link to={'/client/' + record.id}>
                <EditOutlinedIcon />
              </Link>
            )
              :
              (
                <Link to={`/client/${record.id}`} state={{ viewOnly: true }}>
                  <VisibilityIcon />
                </Link>
              )
          }
          {
            user?.permissoes?.cliente?.excluir || user?.permissoes?.client?.isDelete ? (
              <DeleteOutlinedIcon onClick={() => handleDeleteClick(record.id)} color='error' style={{ cursor: "pointer" }} />
            )
              :
              (
                ""
              )
          }
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={datas} loading={loading} />
      <GlobalConfirmModal
        open={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={handleConfirmDelete}
        title="Deseja mesmo excluir?"
        subtitle="Esta ação não poderá ser desfeita."
      />
      <GlobalSuccessModal
        open={openSuccessModal}
        handleClose={() => setOpenSuccessModal(false)}
        title="Cliente excluído com sucesso!"
      />
    </>
  );

};
export default DataClientTable;